module.exports = __webpack_public_path__ + "img/6.96191eb9.png";